import { FETCH_SEARCH_MY_BOOKING } from "app/actionTypes";
import axios from "axios";
import env from "app/utils/env";

export const fetchSearchMyBooking = (bookingReference, lastName) => {
	const url = `${env("ACCOUNT_API_URL")}/getCustomerBooking`;
	const headers = {
		"Content-type": "application/json",
	};
	return {
		type: FETCH_SEARCH_MY_BOOKING,
		promise: axios.post(url, { bookingReference, lastName }, { headers }),
	};
};
